import script from "./OrderProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProduct.vue?vue&type=script&setup=true&lang=js"

import "./OrderProduct.vue?vue&type=style&index=0&id=aeda66e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeda66e8"]])

export default __exports__